import React from 'react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import MobileParametersDropdown from '@/components/MobileParametersDropdown'
import { List } from 'lucide-react'
import { Parameters } from '@/types/parameters'
import { cn } from '@/lib/utils'

interface Props {
  parameters?: Parameters
  disabled?: boolean
  className?: string
}

const ParametersSummaryButton: React.FC<Props> = ({ parameters, disabled, className }) => {
  const hasParametersToShow = Boolean(parameters && (parameters.methodology || parameters.context || parameters.role || parameters.goal))

  const btnClass = cn('h-10 w-10 inline-flex items-center justify-center rounded-md bg-muted text-primary hover:bg-muted/80 disabled:opacity-50 disabled:cursor-not-allowed', className)
  const isDisabled = disabled || !hasParametersToShow

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label="Parameters summary" disabled={isDisabled} className={btnClass}>
          <List className="h-5 w-5" />
        </button>
      </DropdownMenuTrigger>
      {hasParametersToShow && (
        <DropdownMenuContent align="start" sideOffset={8} collisionPadding={16} className="w-[22rem] max-w-[calc(100vw-2rem)] p-0 bg-white border rounded-lg shadow-md">
          <MobileParametersDropdown parameters={parameters!} />
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  )
}

export default ParametersSummaryButton
